import React, { useState } from 'react';
import { createUseStyles } from 'react-jss';
import Lottie from '../common/Lottie';
import LetterAnimation from '../../assets/lotties/LetterAnimation.json';
import LetterAnimationMobile from '../../assets/lotties/LetterAnimationMobile.json';
import TransitionText from '../common/TransitionText';
import { ReactComponent as LinkArrowIcon } from '../../assets/icons/LinkArrowIcon.svg';

const useStyles = createUseStyles(
    {
        wrap: {
            width: '100%',
            height: 'var(--app-height)',
        },

        animationWrap: {
            position: 'relative',
            width: '100%',
            height: '100%',
            overflow: 'hidden',
        },

        animationPortrait: {
            '@media (orientation: landscape)': {
                display: 'none',
            },
        },

        animationLandscape: {
            '@media (orientation: portrait)': {
                display: 'none',
            },
        },

        readMoreButtonWrap: {
            position: 'absolute',
            bottom: 56,
            left: '50%',
            transform: 'translateX(-50%)',
            width: '70%',
            maxWidth: 300,
            textAlign: 'center',
        },

        readMoreButton: {
            fontSize: 18,
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
        },

        copy: {
            fontSize: 18,
            lineHeight: '20px',

            '@media (min-width: 1024px)': {
                fontSize: 24,
                lineHeight: '36px',
            },
        },

        outboundLink: {
            textDecoration: 'none',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            color: 'inherit',

            '& svg': {
                width: 14,
                height: 14,

                '@media (min-width: 1024px)': {
                    width: 20,
                    height: 20,
                },
            },
        },
    },
    { name: 'Letter' }
);

export default function Letter() {
    const classes = useStyles();

    const [paused, setPaused] = useState(false);
    const [readMoreButtonState, setReadMoreButtonState] = useState('init'); // init | in | out

    return (
        <div className={classes.wrap}>
            <div className={classes.animationWrap}>
                <Lottie
                    className={classes.animationLandscape}
                    width={'100%'}
                    height={'100%'}
                    animationData={LetterAnimation}
                    loop={false}
                    paused={paused}
                    onFrame={[
                        {
                            frame: 650,
                            callback: () => {
                                setPaused(true);
                                setReadMoreButtonState('in');
                            },
                        },
                    ]}
                    onCompleteCb={() => {}}
                />
                <Lottie
                    className={classes.animationPortrait}
                    width={'100%'}
                    height={'100%'}
                    animationData={LetterAnimationMobile}
                    loop={false}
                    paused={paused}
                />

                <div className={classes.readMoreButtonWrap}>
                    <TransitionText state={readMoreButtonState}>
                        <div className={classes.copy}>
                            <a
                                href="https://www.bing.com/search?q=sol%20lewitt%20to%20eva%20hesse&msbd=%7B%22triggeringMode%22%3A%22Explicit%22%2C%22intent%22%3A%22UserHistory%22%7D&form=BFBHAS&cvid=D19CA2A1B69C4CD0A65FF06367F7B088&sp=11"
                                target="_blank"
                                rel="noreferrer"
                                className={classes.outboundLink}
                            >
                                <span>
                                    Exit Unlocked&nbsp;
                                    <LinkArrowIcon />
                                </span>

                                <span>
                                    to learn more about Sol’s
                                    <br />
                                    famous letter to Eva Hesse.
                                </span>
                            </a>
                        </div>
                    </TransitionText>
                </div>
            </div>
        </div>
    );
}
